import { CookieState } from '../../slices/cookie'
import { RootState } from '../../types'
import { useSelector } from 'react-redux'

export function useCookieState(): CookieState {
  return useSelector((state: RootState) => state.appReducer.cookieReducer)
}
